import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 px-4 pb-28 pt-10 text-center text-white/55 sm:pb-12" data-id="element-167" data-mp="19j53j40hsmi0">
      <p className="font-display text-xl font-bold text-white" data-id="element-168" data-mp="2071832vrpvxe">PROSTHO 360™</p>
      <p className="mt-1.5 text-[12.5px] uppercase tracking-[0.16em] text-aqua-300" data-id="element-169" data-mp="2f3sa7jwttlqp">
        Understand. Connect. Review. Master.
      </p>
      <p className="mt-5 text-[12.5px]" data-id="element-170" data-mp="2a3ns5pg9siyd">Digital educational material · Personal use</p>
      <p className="mt-1 text-[12.5px]" data-id="element-171" data-mp="1mgo399e6axca">© 2026 · All Rights Reserved.</p>
    </footer>;
}